import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextsTableComponent } from '../../../components/data-display/texts-table/texts-table.compent';
import { AppTextStore } from '../../../services/api/text/app-text-store.service';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { ETextType } from '@web/dtos';

@Component({
  selector: 'aw-texts-for-app-page',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TextsTableComponent,
  ],
  templateUrl: './texts-for-app.component.html',
  styles: ``,
})
export class TextsForAppComponent {
  protected readonly appTextStore: AppTextStore = inject(AppTextStore);
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  protected readonly ETextType: typeof ETextType = ETextType;

  @ViewChild('textTable')
  protected readonly textTableRef!: TextsTableComponent;

  get hasChanges(): boolean {
    return this.textTableRef.hasChanges;
  }
}
